@if (!faqRevampSwitch) {
<div class="card card-background p-5">
  <h1 class="page-title" aria-hidden="true">{{ "FAQS" | globalTranslate }}</h1>
  <div id="accordion">
    @for (itemPar of data; track itemPar) { @for (item of itemPar.questions;
    track item; let i = $index) {
    <div
      class="card card-background p-3"
      (click)="cardClickHandler($event, item)"
    >
      @if (i === 0) {
      <div class="pb-3">
        <h2 class="section-header" role="heading" aria-level="1">
          {{ itemPar.header | globalTranslate }}
        </h2>
        <hr />
      </div>
      }
      <div
        role="button"
        tabindex="0"
        [attr.aria-expanded]="item.show"
        [attr.aria-label]="
          (item.key | globalTranslate) +
          (item.show
            ? ', ' + ('EXPANDED' | globalTranslate)
            : ', ' + ('COLLAPSED' | globalTranslate))
        "
        attr.aria-controls="collapse{{ item.key | globalTranslate }}"
        (keydown.enter)="showHide(item)"
        (keydown.space)="showHide(item); $event.preventDefault()"
      >
        <h2 aria-hidden="true">
          <div
            data-toggle="collapse"
            attr.data-target="#collapse{{ item.key | globalTranslate }}"
          >
            <div class="d-flex align-items-center">
              <div class="item-key">
                <strong>{{ item.key | globalTranslate }}</strong>
              </div>
              @if (item.show) {
              <div
                class="ms-3 item-key-symbol"
                aria-hidden="true"
                role="presentation"
              >
                <i class="fa fa-angle-up"></i>
              </div>
              } @if (!item.show) {
              <div
                class="ms-3 item-key-symbol"
                aria-hidden="true"
                role="presentation"
              >
                <i class="fa fa-angle-down"></i>
              </div>
              }
            </div>
          </div>
        </h2>
      </div>
      <div
        id="collapse{{ i }}"
        [ngClass]="{ show: item.show }"
        class="collapse"
        aria-labelledby="headingOne"
        data-bs-parent="#accordion"
      >
        <div class="card-body">
          <div [innerHtml]="item.value | globalTranslate"></div>
        </div>
      </div>
    </div>
    } }
  </div>
</div>
}

<!-- New FAQ Design -->
@if (faqRevampSwitch) {
<div class="container my-3 p-4">
  <div class="row">
    <div class="col-12">
      @if (this.language === 'es') {
      <h1 class="page-title">{{ "FAQ_HEADER_TEXT" | globalTranslate }}</h1>
      } @if (this.language !== 'es') {
      <h1 class="page-title">
        {{ "FAQ_HEADER_TEXT" | globalTranslate }} <span>({{ "FAQs" }})</span>
      </h1>
      }
    </div>
  </div>
  <div class="bg-white p-4">
    <p class="faq-search-instruction">
      {{ "FAQ_SEARCH_INSTRUCTION" | globalTranslate }}
    </p>
    <div class="faq-revamp-container">
      <!-- Search Section -->
      <div class="faq-search-section" role="search">
        <div class="search-input-wrapper">
          <label for="faqSearchInput"
            ><strong>{{ "FAQ_SEARCH_LABEL" | globalTranslate }}</strong></label
          >
          <div class="search-input-container">
            <input
              type="search"
              id="faqSearchInput"
              class="faq-search-input"
              [placeholder]="'FAQ_SEARCH_PLACEHOLDER' | globalTranslate"
              [(ngModel)]="searchQuery"
              (input)="onSearchInput($event)"
              [attr.aria-label]="'FAQ_SEARCH_LABEL' | globalTranslate"
              aria-describedby="faqSearchInstruction"
            />
            @if (searchQuery) {
            <button
              type="button"
              class="faq-search-clear-btn"
              (click)="clearSearch()"
              [attr.aria-label]="'Clear search'"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            }
          </div>
        </div>
      </div>
      <hr class="divider search-divider" />
      <!-- No Results Message -->
      @if (isSearching && searchResults.length === 0) {
      <div class="faq-no-results">
        <p>{{ "FAQ_NO_RESULTS_MESSAGE" | globalTranslate }}</p>
      </div>
      }
      <!-- Search Results -->
      @if (isSearching && searchResults.length > 0) {
      <div class="faq-search-results">
        <div id="searchAccordion">
          @for (item of searchResults; track item; let i = $index) {
          <div class="faq-question-item">
            <div
              class="faq-question-header"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="item.show"
              [attr.aria-label]="
                (item.key | globalTranslate) +
                (item.show
                  ? ', ' + ('EXPANDED' | globalTranslate)
                  : ', ' + ('COLLAPSED' | globalTranslate))
              "
              [attr.aria-controls]="'searchCollapse' + i"
              (click)="showHide(item)"
              (keydown.enter)="showHide(item)"
              (keydown.space)="showHide(item); $event.preventDefault()"
            >
              <div class="d-flex align-items-start">
                <p class="item-key">
                  <strong [innerHtml]="item.key | globalTranslate"></strong>
                </p>
                @if (item.show) {
                <div
                  class="item-key-symbol"
                  aria-hidden="true"
                  role="presentation"
                >
                  <i class="fa fa-angle-up"></i>
                </div>
                } @if (!item.show) {
                <div
                  class="item-key-symbol"
                  aria-hidden="true"
                  role="presentation"
                >
                  <i class="fa fa-angle-down"></i>
                </div>
                }
              </div>
            </div>
            <div
              [id]="'searchCollapse' + i"
              [ngClass]="{ show: item.show }"
              class="collapse text-width"
              aria-labelledby="headingOneList"
              data-bs-parent="#searchAccordion"
            >
              <div class="card-body">
                <p [innerHtml]="item.value === 'FAQ_VALUE_46' ? (formatFaqAnswer(item.value) | globalTranslate) : (item.value | globalTranslate)"></p>
              </div>
            </div>
            @if (i < searchResults.length - 1) {
            <hr [style.margin-top]="item.show ? '50px' : '30px'" />
            }
          </div>
          }
        </div>
      </div>
      } @if (!isSearching) {
      <div class="faq-browse-categories">
        <h2>{{ "FAQ_BROWSE_CATEGORIES" | globalTranslate }}</h2>
        <p>{{ "FAQ_BROWSE_CATEGORIES_MESSAGE" | globalTranslate }}</p>
      </div>
      }
      <!-- Tiles Section -->
      @if (!isSearching) {
      <div
        class="faq-categories-grid"
        role="list"
        [attr.aria-label]="'FAQ_CATEGORIES_LABEL' | globalTranslate"
        [class.faq-grid-rp]="userType === 'RP'"
      >
        @for (category of categories; track category) {
        <div
          class="faq-category-card"
          role="listitem"
          tabindex="0"
          (click)="onCategoryClick(category.id)"
          (keydown.enter)="onCategoryClick(category.id)"
          (keydown.space)="
            onCategoryClick(category.id); $event.preventDefault()
          "
          [attr.aria-label]="category.title | globalTranslate"
        >
          <div class="category-content">
            <div class="category-icon" aria-hidden="true">
              <img [src]="category.icon" alt="" />
            </div>
            <h3 class="category-title">
              {{ category.title | globalTranslate }}
            </h3>
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
}